(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {
    console.log("sticky full: " + sticky)

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["op-collection-premium"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('op-collection-catalog')) {
  class OPCollectionCatalog extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.large = this.dataset.large === 'true';
      this.addEventListener('click', this.click.bind(this), options);
      this.addEventListener('change', this.change.bind(this), options);
      this.addEventListener('submit', this.submit.bind(this), options);
      this.addEventListener('pointerover', this.hover.bind(this), options);
      this.addEventListener('pointerout', this.leave.bind(this), options);
      this.addEventListener('touchstart',this.startTouch.bind(this),{...options,passive:true});
      document.addEventListener('touchmove',this.moveTouch.bind(this),{...options,passive:true});
      document.addEventListener('touchend',this.endTouch.bind(this),{...options,passive:true});
      document.addEventListener('touchcancel',()=>this.clearFinger(),{...options,passive:true});
      this.addEventListener('pointerdown',this.startPointer.bind(this),{...options,passive:true});
      document.addEventListener('pointermove',this.movePointer.bind(this),{...options,passive:true});
      document.addEventListener('pointerup',this.endPointer.bind(this),{...options,passive:true});
      document.addEventListener('pointercancel',event=>{if(this.finger?.source==='pointer'&&this.finger.id===event.pointerId)this.clearFinger();},options);
      window.addEventListener('scroll',this.scrollFinger.bind(this),{...options,passive:true});
      window.addEventListener('blur',()=>this.clearFinger(),options);
      document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')this.clearFinger();},options);
      this.addEventListener('dragstart', event => {if(event.target.closest('[data-photo-link]'))event.preventDefault();}, options);
      window.addEventListener('popstate', () => this.navigate(location.href, false), options);
      this.prepare();
    }
    disconnectedCallback() { this.clearFinger(); this.events?.abort(); this.request?.abort(); this.observer?.disconnect(); this.photoObserver?.disconnect(); this.pendingCard=null; if(this.contains(window.opCatalogActiveCard))window.opCatalogActiveCard=null; this.unlock(); }
    prepare() {
      this.clearFinger();
      this.pendingCard=null;
      if(window.opCatalogActiveCard && !window.opCatalogActiveCard.isConnected)window.opCatalogActiveCard=null;
      const dialog=this.querySelector('dialog');
      dialog?.addEventListener('close', () => this.unlock(), {signal:this.events.signal});
      dialog?.addEventListener('cancel', () => this.unlock(), {signal:this.events.signal});
      this.querySelector('[data-toggle-view]')?.setAttribute('aria-pressed', String(this.large));
      this.photoObserver?.disconnect();
      if ('IntersectionObserver' in window) {
        this.photoObserver=new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.preparePhoto(entry.target);
          this.photoObserver.unobserve(entry.target);
        }), {rootMargin:'250px 0px', threshold:.01});
        this.querySelectorAll('[data-two-images]').forEach(card => this.photoObserver.observe(card));
      }
      this.observer?.disconnect();
      if (this.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      this.observer=new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('oc-reveal'); this.observer.unobserve(entry.target);
      }), {threshold:.06});
      this.querySelectorAll('[data-card]').forEach((card,index) => {const rect=card.getBoundingClientRect();if(rect.top<innerHeight && rect.bottom>0){card.style.setProperty('--oc-delay','0ms');card.classList.add('oc-reveal');return;}card.style.setProperty('--oc-delay',(index%4)*45+'ms');this.observer.observe(card);});
    }
    preparePhoto(card) {
      const image=card.querySelector('.op-catalog-card__image--second');
      if (!image) return Promise.resolve(false);
      this.photoLoads ||= new WeakMap();
      if (this.photoLoads.has(image)) return this.photoLoads.get(image);
      image.fetchPriority='low';
      if (image.dataset.srcset) {image.srcset=image.dataset.srcset;delete image.dataset.srcset;}
      if (image.dataset.src) {image.src=image.dataset.src;delete image.dataset.src;}
      image.loading='eager';
      const loaded=image.complete && image.naturalWidth ? Promise.resolve() : new Promise(resolve => {
        const done=() => {image.removeEventListener('load',done);image.removeEventListener('error',done);resolve();};
        image.addEventListener('load',done);image.addEventListener('error',done);
      });
      const ready=loaded.then(async () => {
        if (image.decode) {try {await image.decode();} catch (_) {}}
        if (!image.naturalWidth) return false;
        image.dataset.photoReady='true';return true;
      });
      this.photoLoads.set(image,ready);
      return ready;
    }
    activate(card,index) {
      if (index===1) {
        this.pendingCard=card;
        const image=card.querySelector('.op-catalog-card__image--second');
        if (!image || image.dataset.photoReady!=='true') {
          this.preparePhoto(card).then(ready => {if(ready && this.pendingCard===card && card.isConnected)this.activate(card,1);});
          return;
        }
      } else if (this.pendingCard===card) this.pendingCard=null;
      if (index===1 && window.opCatalogActiveCard && window.opCatalogActiveCard!==card) this.activate(window.opCatalogActiveCard,0);
      card.dataset.activePhoto=String(index);
      card.querySelectorAll('[data-photo]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.photo)===index)));
      if (index===1) window.opCatalogActiveCard=card;
      else if (window.opCatalogActiveCard===card) window.opCatalogActiveCard=null;
    }
    hover(event) {
      if (event.pointerType!=='mouse' || !matchMedia('(hover:hover)').matches) return;
      const card=event.target.closest('[data-two-images]');
      if (card && !card.contains(event.relatedTarget)) this.activate(card,1);
    }
    leave(event) {
      if (event.pointerType!=='mouse') return;
      const card=event.target.closest('[data-two-images]');
      if (card && !card.contains(event.relatedTarget)) this.activate(card,0);
    }
    beginFinger(point,source,target) {
      this.clearFinger();
      this.touchClickUntil=0;
      if(this.dataset.swipe!=='true'||target.closest('button,input,select,textarea,dialog'))return;
      this.finger={id:point.identifier??point.pointerId,source,x:point.clientX,y:point.clientY,startX:point.clientX,startY:point.clientY,scroll:window.scrollY,started:performance.now(),moved:false,previewed:false};
      this.fingerTimer=setTimeout(()=>this.previewFinger(true),Number(this.dataset.touchDelay)||140);
    }
    startTouch(event) {
      if(event.touches.length!==1){this.clearFinger();return;}
      this.beginFinger(event.touches[0],'touch',event.target);
    }
    moveTouch(event) {
      if(this.finger?.source!=='touch')return;
      if(event.touches.length!==1){this.clearFinger();return;}
      const point=Array.from(event.touches).find(point=>point.identifier===this.finger.id);
      if(point)this.moveFinger(point);
    }
    endTouch(event) {
      if(this.finger?.source!=='touch')return;
      const point=Array.from(event.changedTouches).find(point=>point.identifier===this.finger.id);
      if(point)this.finishFinger(point);
    }
    startPointer(event) {
      if(event.pointerType==='mouse'||event.isPrimary===false)return;
      if(event.pointerType==='touch'&&'ontouchstart' in window)return;
      this.beginFinger(event,'pointer',event.target);
    }
    movePointer(event) {
      if(this.finger?.source==='pointer'&&this.finger.id===event.pointerId)this.moveFinger(event);
    }
    endPointer(event) {
      if(this.finger?.source==='pointer'&&this.finger.id===event.pointerId)this.finishFinger(event);
    }
    moveFinger(point) {
      const finger=this.finger;
      if(!finger)return;
      finger.x=point.clientX;finger.y=point.clientY;
      if(Math.hypot(finger.x-finger.startX,finger.y-finger.startY)>8||Math.abs(window.scrollY-finger.scroll)>5)finger.moved=true;
      if(finger.moved){clearTimeout(this.fingerTimer);this.queueFinger();}
    }
    scrollFinger() {
      if(!this.finger)return;
      if(Math.abs(window.scrollY-this.finger.scroll)>5)this.finger.moved=true;
      if(this.finger.moved){clearTimeout(this.fingerTimer);this.queueFinger();}
    }
    queueFinger() {
      if(!this.fingerFrame)this.fingerFrame=requestAnimationFrame(()=>{this.fingerFrame=0;this.previewFinger();});
    }
    previewFinger(settled=false) {
      const finger=this.finger;
      if(!finger||this.dataset.swipe!=='true')return;
      if(!settled&&!finger.moved&&performance.now()-finger.started<(Number(this.dataset.touchDelay)||140))return;
      const target=document.elementFromPoint(finger.x,finger.y);
      const link=target?.closest('[data-photo-link]')||target?.closest('.op-catalog-card__media')?.querySelector('[data-photo-link]');
      const card=link?.closest('[data-two-images]');
      if(!card||!this.contains(card))return;
      if(window.opCatalogActiveCard!==card)this.activate(card,1);
      finger.previewed=true;
    }
    finishFinger(point) {
      const finger=this.finger;
      if(!finger)return;
      this.moveFinger(point);
      this.previewFinger();
      const held=performance.now()-finger.started>=(Number(this.dataset.touchHold)||340);
      if(finger.moved||(held&&finger.previewed))this.touchClickUntil=performance.now()+700;
      this.clearFinger();
    }
    clearFinger() {
      clearTimeout(this.fingerTimer);
      cancelAnimationFrame(this.fingerFrame||0);
      this.finger=null;this.fingerFrame=0;
    }
    click(event) {
      const photo=event.target.closest('[data-photo]');
      if (photo) {event.preventDefault();this.activate(photo.closest('[data-card]'),Number(photo.dataset.photo));return;}
      if (event.target.closest('[data-photo-link]') && event.detail!==0 && event.pointerType!=='mouse' && performance.now()<(this.touchClickUntil||0)) {event.preventDefault();return;}
      const open=event.target.closest('[data-open-filters]');
      if (open) {const dialog=this.querySelector('dialog');if(dialog?.showModal){this.savedOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();}return;}
      if (event.target.closest('[data-close-filters]')) {this.querySelector('dialog')?.close();return;}
      if (event.target===this.querySelector('dialog')) {const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();return;}
      if (event.target.closest('[data-toggle-view]')) {this.large=!this.large;this.dataset.large=String(this.large);this.prepare();return;}
      const link=event.target.closest('a[data-catalog-nav]');
      if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {event.preventDefault();this.querySelector('dialog')?.close();this.navigate(link.href,true,link.closest('.op-catalog__pagination')!==null);}
    }
    unlock() {if(this.savedOverflow!==undefined){document.documentElement.style.overflow=this.savedOverflow;this.savedOverflow=undefined;}}
    formURL() {
      const url=new URL(location.href);url.searchParams.delete('page');
      for(const key of [...url.searchParams.keys()])if(key.startsWith('filter.')||key==='sort_by')url.searchParams.delete(key);
      const form=this.querySelector('[data-filter-form]');
      for(const [key,value] of new FormData(form))if(String(value).trim()!=='')url.searchParams.append(key,value);
      return url;
    }
    change(event) {if(event.target.matches('[data-sort]'))this.navigate(this.formURL());}
    submit(event) {if(!event.target.matches('[data-filter-form]'))return;event.preventDefault();this.querySelector('dialog')?.close();this.navigate(this.formURL());}
    async navigate(target,push=true,scroll=false) {
      this.request?.abort();const controller=new AbortController();this.request=controller;
      const url=new URL(target,location.href),current=new URL(location.href);
      ['view','preview_theme_id'].forEach(key=>{if(current.searchParams.has(key)&&!url.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));});
      const requestURL=new URL(url);requestURL.searchParams.set('section_id',this.dataset.sectionId);
      const focused=document.activeElement?.id;
      this.setAttribute('aria-busy','true');this.querySelector('[data-catalog-error]').hidden=true;
      try {
        const response=await fetch(requestURL,{signal:controller.signal});if(!response.ok)throw new Error('catalog');
        const documentHTML=new DOMParser().parseFromString(await response.text(),'text/html');
        const content=documentHTML.querySelector('[data-catalog-body]');if(!content)throw new Error('catalog');
        this.unlock();this.querySelector('[data-catalog-body]').innerHTML=content.innerHTML;
        if(window.opCatalogActiveCard&&!window.opCatalogActiveCard.isConnected)window.opCatalogActiveCard=null;
        if(push)history.pushState({},'',url);this.prepare();
        const focusTarget=(focused&&this.querySelector('[id="'+CSS.escape(focused)+'"]'))||this.querySelector('[data-open-filters]');
        focusTarget?.focus({preventScroll:true});
        if(scroll)this.querySelector('[data-catalog-toolbar]').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      } catch(error) {if(error.name!=='AbortError')this.querySelector('[data-catalog-error]').hidden=false;}
      finally {if(this.request===controller)this.removeAttribute('aria-busy');}
    }
  }
  customElements.define('op-collection-catalog',OPCollectionCatalog);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["op-global-header"]) return;
  try {
    

if(!window.opSearchBackdropBound){
  window.opSearchBackdropBound=true;
  document.addEventListener('click',event=>{
    if(event.target.matches('.opgh-search.is-open'))event.target.querySelector('[data-opgh-search-close]')?.click();
  });
}


(() => {
  if (window.opNavPremiumBound) return;
  window.opNavPremiumBound = true;
  const opening = new WeakMap();
  const closing = new WeakMap();
  const accordionMotion = new WeakMap();
  const accordionTarget = new WeakMap();
  const coarse = () => !matchMedia('(hover:hover) and (pointer:fine)').matches;
  const motion = panel => panel.dataset.menuMotion !== 'false' && !matchMedia('(prefers-reduced-motion:reduce)').matches;
  const closeItem = item => {
    clearTimeout(opening.get(item));
    clearTimeout(closing.get(item));
    item.classList.remove('is-nav-open');
    delete item.dataset.opgnPinned;
    item.querySelector('[data-opgn-toggle]')?.setAttribute('aria-expanded', 'false');
  };
  const closeAll = except => document.querySelectorAll('.opgn-header .opgh__desktop-item').forEach(item => { if (item !== except) closeItem(item); });
  const openItem = item => {
    if (!item?.querySelector('[data-opgn-dropdown]')) return;
    clearTimeout(opening.get(item));
    clearTimeout(closing.get(item));
    closeAll(item);
    item.classList.add('is-nav-open');
    item.querySelector('[data-opgn-toggle]').setAttribute('aria-expanded', 'true');
  };
  const toggleAccordion = (details, expanded) => {
    const content = details.querySelector('.opgn-submenu-content');
    const panel = details.closest('.opgn-mobile');
    const previous = accordionMotion.get(details);
    accordionTarget.set(details, expanded);
    const startingHeight = details.open ? content.getBoundingClientRect().height : 0;
    previous?.cancel();
    if (!motion(panel)) { details.open = expanded; return; }
    details.open = true;
    const height = content.scrollHeight;
    const animation = content.animate([{height:startingHeight+'px',opacity:expanded ? .3 : 1},{height:(expanded ? height : 0)+'px',opacity:expanded ? 1 : 0}],{duration:240,easing:'cubic-bezier(.22,1,.36,1)'});
    accordionMotion.set(details, animation);
    animation.onfinish = () => { details.open = expanded; accordionMotion.delete(details); };
  };
  document.addEventListener('pointerover', event => {
    if (coarse()) return;
    const item = event.target.closest('.opgn-header .opgh__desktop-item--has-menu');
    if (!item || item.contains(event.relatedTarget)) return;
    clearTimeout(closing.get(item));
    opening.set(item, setTimeout(() => openItem(item), 85));
  });
  document.addEventListener('pointerout', event => {
    if (coarse()) return;
    const item = event.target.closest('.opgn-header .opgh__desktop-item--has-menu');
    if (!item || item.contains(event.relatedTarget)) return;
    clearTimeout(opening.get(item));
    closing.set(item, setTimeout(() => closeItem(item), 140));
  });
  document.addEventListener('focusin', event => {
    const item = event.target.closest('.opgn-header .opgh__desktop-item');
    if (item && event.target.matches('a')) openItem(item);
  });
  document.addEventListener('focusout', event => {
    const item = event.target.closest('.opgn-header .opgh__desktop-item');
    if (item && !item.contains(event.relatedTarget)) closeItem(item);
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-opgn-toggle]');
    if (toggle) { const item = toggle.closest('.opgh__desktop-item'); if (item.dataset.opgnPinned === 'true') closeItem(item); else { openItem(item); item.dataset.opgnPinned = 'true'; } return; }
    const close = event.target.closest('[data-opgn-close]');
    if (close) { const id = close.closest('.opgn-mobile').dataset.opghMobilePanel; document.querySelector('[data-opgh-section-id="'+id+'"] [data-opgh-menu-toggle]')?.click(); return; }
    const summary = event.target.closest('.opgn-mobile .opgh__mobile-submenu>summary');
    if (summary) {
      event.preventDefault();
      const details = summary.parentElement;
      const expanded = accordionMotion.has(details) ? !accordionTarget.get(details) : !details.open;
      details.closest('.opgn-mobile').querySelectorAll('.opgh__mobile-submenu[open]').forEach(other => { if (other !== details) toggleAccordion(other, false); });
      toggleAccordion(details, expanded);
      return;
    }
    if (!event.target.closest('.opgn-header .opgh__desktop-menu')) closeAll();
  });
  document.addEventListener('keydown', event => {
    const item = event.target.closest('.opgn-header .opgh__desktop-item');
    if (event.key === 'Escape' && item?.classList.contains('is-nav-open')) { event.preventDefault(); closeItem(item); item.querySelector('[data-opgn-toggle]')?.focus(); }
    if (event.key === 'ArrowDown' && item && event.target.closest('[data-opgn-toggle]')) { event.preventDefault(); openItem(item); item.querySelector('.opgh__dropdown a')?.focus(); }
    if (event.key === 'Tab') {
      const panel = document.querySelector('.opgn-mobile.is-open');
      if (!panel) return;
      const elements = Array.from(panel.querySelectorAll('a[href],button,summary')).filter(e => e.offsetParent !== null);
      if (!elements.length) return;
      event.stopPropagation();
      const first = elements[0], last = elements[elements.length-1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }, true);
  window.addEventListener('resize', () => { if (innerWidth <= 1024) closeAll(); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["op-home-motion"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.OroPlataMotion) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  let cleanup = () => {};
  const init = () => {
    cleanup();
    const config = document.querySelector('[data-op-home-motion]');
    const main = document.querySelector('#MainContent');
    if (!config || !main) return;
    const body = document.body;
    const active = config.dataset.enabled === 'true' && !reduced.matches;
    const controller = new AbortController();
    const signal = controller.signal;
    const animations = new Set();
    const observed = new Set();
    const stages = new Set();
    const visibleStages = new Set();
    const pressed = new Set();
    const number = (key, fallback) => Number(config.dataset[key]) || fallback;
    const duration = number('duration', 620);
    const distance = number('distance', 14);
    const stagger = Number(config.dataset.stagger) || 0;
    const enabled = (key) => active && config.dataset[key] === 'true';
    let frame = 0;
    let revealObserver;
    let stageObserver;
    body.dataset.opMotionMode = active ? 'on' : 'off';
    body.dataset.opMotionImages = String(enabled('images'));
    body.style.setProperty('--op-motion-duration', `${duration}ms`);
    body.style.setProperty('--op-motion-zoom', String(number('zoom', 103.5) / 100));
    body.style.setProperty('--op-motion-press', String(number('press', 98) / 100));
    const finishPress = () => {
      pressed.forEach(el => el.removeAttribute('data-op-pressed'));
      pressed.clear();
    };
    const animate = el => {
      if (!el.isConnected || el.closest('[hidden], dialog')) return;
      const animation = el.animate([
        { opacity: 0, transform: `translate3d(0,${finePointer.matches && innerWidth > 749 ? distance : Math.min(distance, 12)}px,0)` },
        { opacity: 1, transform: 'translate3d(0,0,0)' }
      ], {
        duration,
        delay: Number(el.dataset.opMotionDelay) || 0,
        easing: 'cubic-bezier(.22,1,.36,1)',
        fill: 'backwards'
      });
      animations.add(animation);
      const finish = () => animations.delete(animation);
      animation.addEventListener('finish', finish, { once: true });
      animation.addEventListener('cancel', finish, { once: true });
    };
    if (enabled('reveal') && !window.Shopify?.designMode && 'IntersectionObserver' in window && Element.prototype.animate) {
      revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        revealObserver.unobserve(entry.target);
        animate(entry.target);
      }), { threshold: .06, rootMargin: '0px 0px -24px 0px' });
    }
    const bind = scope => {
      const units = scope.querySelectorAll([
        '.op-section-heading .op-kicker', '.op-section-heading h2', '.op-section-heading__text',
        '.op-hero__content > *', '.op-intent-card', '.op-gift-card',
        '.op-product-rail__item', '.op-ugc-card', '.op-section-end',
        '.op-story__content > *', '.op-packaging__content > *', '.op-benefits > div', '.op-provider'
      ].join(','));
      const groups = new Map();
      units.forEach(el => {
        if (observed.has(el)) return;
        observed.add(el);
        el.dataset.opMotionUnit = 'true';
        const group = el.closest('.op-section-heading, .op-hero__content, .op-intents__rail, .op-gifting__grid, .op-product-rail, .op-ugc__rail') || el.parentElement;
        const index = groups.get(group) || 0;
        groups.set(group, index + 1);
        el.dataset.opMotionDelay = String(Math.min(index, 3) * stagger);
        const rect = el.getBoundingClientRect();
        if (rect.top < innerHeight - 24 && rect.bottom > 0) return;
        revealObserver?.observe(el);
      });
      if (enabled('footer') && revealObserver) {
        document.querySelectorAll('.op-footer__brand, .op-footer__menus, .op-footer__newsletter').forEach(el => {
          if (observed.has(el)) return;
          observed.add(el);
          if (el.getBoundingClientRect().top >= innerHeight) revealObserver.observe(el);
        });
      }
      if (enabled('buttons')) {
        const roots = [scope, document.querySelector('.opgh')];
        if (enabled('footer')) roots.push(document.querySelector('.op-footer'));
        roots.filter(Boolean).forEach(root => root.querySelectorAll('a, button').forEach(el => {
          if (el.matches(':disabled') || el.hasAttribute('data-op-motion-button')) return;
          if (!el.matches('button, .op-button, .op-hero__link, .op-text-link, .opgh__icon-button, .op-footer a')) return;
          el.dataset.opMotionButton = 'true';
        }));
      }
      if (enabled('drift') && stageObserver) scope.querySelectorAll('.op-hero__media').forEach(el => {
        if (stages.has(el)) return;
        stages.add(el);
        el.dataset.opMotionStage = 'true';
        stageObserver.observe(el.parentElement);
      });
    };
    const updateStages = () => {
      frame = 0;
      const depth = Math.min(Number(config.dataset.depth) || 0, finePointer.matches && innerWidth > 749 ? 20 : 7);
      const updates = [...visibleStages].map(el => {
        const rect = el.parentElement.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / ((innerHeight + rect.height) / 2)));
        return [el, progress * depth, 1 + (depth * 2 + 2) / Math.max(rect.height, 1)];
      });
      updates.forEach(([el, shift, scale]) => {
        el.style.setProperty('--op-motion-shift', `${shift.toFixed(2)}px`);
        el.style.setProperty('--op-motion-stage-scale', String(scale));
      });
    };
    const schedule = () => {
      if (!frame && visibleStages.size && document.visibilityState === 'visible') frame = requestAnimationFrame(updateStages);
    };
    if (enabled('drift') && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
      stageObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const el = entry.target.querySelector('[data-op-motion-stage]');
          if (!el) return;
          if (entry.isIntersecting) visibleStages.add(el);
          else visibleStages.delete(el);
        });
        schedule();
      }, { rootMargin: '80px 0px', threshold: 0 });
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
    }
    bind(main);
    const intents = main.querySelector('.op-intents');
    const anchorLinks = [];
    if (intents) main.querySelectorAll('a[href*="__op_intents"]').forEach(el => {
      anchorLinks.push([el, el.getAttribute('href')]);
      el.setAttribute('href', `#${intents.id}`);
    });
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a');
      if (!link || !intents || link.getAttribute('href') !== `#${intents.id}`) return;
      event.preventDefault();
      const header = document.querySelector('.opgh');
      intents.style.scrollMarginTop = `${Math.min(header?.getBoundingClientRect().height || 80, 220)}px`;
      intents.scrollIntoView({ behavior: active ? 'smooth' : 'auto', block: 'start' });
    }, { signal });
    document.addEventListener('pointerdown', event => {
      if (!enabled('buttons') || event.button !== 0) return;
      const el = event.target.closest('[data-op-motion-button]');
      if (!el || el.matches(':disabled')) return;
      pressed.add(el);
      el.dataset.opPressed = 'true';
    }, { passive: true, signal });
    ['pointerup', 'pointercancel', 'scroll', 'visibilitychange'].forEach(type => {
      document.addEventListener(type, finishPress, { passive: true, capture: type === 'scroll', signal });
    });
    window.addEventListener('blur', finishPress, { signal });
    document.addEventListener('shopify:section:load', event => {
      if (event.target.querySelector('[data-op-home-motion]')) return;
      bind(event.target);
    }, { signal });
    document.addEventListener('shopify:section:unload', event => {
      observed.forEach(el => {
        if (!event.target.contains(el)) return;
        revealObserver?.unobserve(el);
        observed.delete(el);
      });
      stages.forEach(el => {
        if (!event.target.contains(el)) return;
        stageObserver?.unobserve(el.parentElement);
        visibleStages.delete(el);
        stages.delete(el);
      });
    }, { signal });
    window.addEventListener('pageshow', finishPress, { signal });
    cleanup = () => {
      controller.abort();
      revealObserver?.disconnect();
      stageObserver?.disconnect();
      cancelAnimationFrame(frame);
      finishPress();
      animations.forEach(animation => animation.cancel());
      anchorLinks.forEach(([el, href]) => el.setAttribute('href', href));
      stages.forEach(el => {
        el.removeAttribute('data-op-motion-stage');
        el.style.removeProperty('--op-motion-shift');
        el.style.removeProperty('--op-motion-stage-scale');
      });
      observed.forEach(el => {
        el.removeAttribute('data-op-motion-unit');
        el.removeAttribute('data-op-motion-delay');
      });
      document.querySelectorAll('[data-op-motion-button]').forEach(el => el.removeAttribute('data-op-motion-button'));
      body.removeAttribute('data-op-motion-mode');
      body.removeAttribute('data-op-motion-images');
      ['duration', 'zoom', 'press'].forEach(key => body.style.removeProperty(`--op-motion-${key}`));
    };
  };
  window.OroPlataMotion = { init, destroy: () => cleanup() };
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('[data-op-home-motion]')) init();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-op-home-motion]')) cleanup();
  });
  reduced.addEventListener('change', init);
  finePointer.addEventListener('change', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
